import React, { useState, useEffect } from 'react';
import { ArrowUp } from 'lucide-react';

/**
 * Clean floating ScrollToTopButton utility.
 * Appears when scrolling down and smoothly resets view back to the top.
 */
export default function ScrollToTopButton() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      setIsVisible(window.scrollY > 300);
    };

    window.addEventListener('scroll', toggleVisibility, { passive: true });
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <button
      onClick={scrollToTop}
      className={`fixed bottom-6 right-6 z-40 p-3 bg-white border border-[#793bfb]/20 hover:border-[#793bfb] hover:text-primary text-zinc-800 rounded-full shadow-lg transition-all duration-300 focus:outline-none hover:-translate-y-1 hover:shadow-xl active:translate-y-0 ${
        isVisible ? 'opacity-100 translate-y-0 pointer-events-auto' : 'opacity-0 translate-y-3 pointer-events-none'
      }`}
      aria-label="Scroll to top"
    >
      <ArrowUp className="w-5 h-5 stroke-[2.5]" />
    </button>
  );
}
